import React, { Component } from "react";
import {EkoFormButton, EkoFormSelect} from "../elements/EkoForm";
import { toastr } from "react-redux-toastr";
import * as actions from "../../actions";
import { connect } from "react-redux";
import Api from "../../util/Api";
import EkoSpinner from "../elements/EkoSpinner";
import "sweetalert/dist/sweetalert.css";
import PaymentRecorderDeviceInfoModal from "./paymentRecorderDeviceInfoModal";
import { EkoFormInputText } from "../elements/EkoForm";
import EkoModal from "../elements/EkoModal";

class paymentRecorderDeviceInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showInsertModal: false,
            errors: {},
            page_loading: false,
            records: {},
            bankAccountList: [],
            warehouseList: [],
            selectedRecord: null,
            showUsersModal: false,
            users:[],
            selectedRecordPermission:null,
            selectedUserIds: []
        };
    }
    getUserList(){
        Api.get("/company/getUserList", (response, errors) => {
            if (errors) {
                toastr.error("Hata", "Kullanıcı listesi alınırken hata oluştu.");
            } else {
                this.setState({ users: response.data || [] });
            }
        });
    }
    componentWillMount() {
        this.setState({ page_loading: true });
        this.getUserList();
        this.getList();
    }
    getList(){
        Api.get("/company/paymentRecorderDeviceList", (res, err) => {
            if (err) {
                toastr.error("Hata", err.error ?? "Beklenmeyen bir hata oluştu!");
                this.setState({ page_loading: false });
                return;
            }
            this.setState({ records: res.list, page_loading: false });
        });
    }
    componentWillReceiveProps(nextProps) {}
    onSave() {}

    openInsert(record = null) {
        this.getBankAccountsList();
        this.fetchAllWarehouses();
        this.setState({
            selectedRecord: record,
            showInsertModal: true
        });
    }

    hideModalHandler(addUpdate = false) {
        if (addUpdate) {
            this.componentWillMount();
        }
        this.setState({ showInsertModal: false });
    }

    getBankAccountsList = async () => {
        Api.get("/bankAccount/list", (response, errors) => {
            if (response.status == "ok") {
                this.setState({ bankAccountList: response.bankAccounts });
            }
        });
    }

    fetchAllWarehouses = async () => {
        Api.get("/warehouses/showAll", (response, errors) => {
            if (!errors) {
                this.setState({
                    warehouseList: response.items,
                });
            }
        });
    }
    form(fields) {
        const isPavo = String(fields.formData?.integration_company ?? "0") === "1";

        return (
            <>
                <EkoFormSelect
                    {...fields}
                    label={"Entegrator Firma"}
                    name={"integration_company"}
                    id={"integration_company"}
                    options={[
                        { id: "0", name: "Ödeal" },
                        { id: "1", name: "Pavo" },
                    ]}
                />
                <EkoFormSelect
                    {...fields}
                    label={"Cihaz Tipi"}
                    name={"device_type"}
                    id={"device_type"}
                    options={[
                        { id: 0, name: "D2D (Web Entegrasyonu)" },
                        { id: 1, name: "A2A (Mobil App Entegrasyonu)" },
                    ]}
                />
                <EkoFormSelect
                    {...fields}
                    label={"Nakit Kasa"}
                    name={"cash_bank_id"}
                    id={"cash_bank_id"}
                    options={
                        this.state.bankAccountList
                            .filter(account => account.bank_account_type === 1)
                            .map(account => ({ id: account.id, name: account.name }))
                    }
                />
                <EkoFormSelect
                    {...fields}
                    label={"Kredi Kartı Kasa"}
                    name={"credit_card_bank_id"}
                    id={"credit_card_bank_id"}
                    options={
                        this.state.bankAccountList
                            .filter(account => account.bank_account_type === 4)
                            .map(account => ({ id: account.id, name: account.name }))
                    }
                />
                <EkoFormSelect
                    {...fields}
                    label={"Depo"}
                    name={"warehouse_id"}
                    id={"warehouse_id"}
                    options={this.state.warehouseList}
                />
                <EkoFormInputText
                    {...fields}
                    label={"Başlık"}
                    id={"title"}
                    name={"title"}
                />
                {!isPavo && (
                    <>
                        <EkoFormInputText
                            {...fields}
                            label={"Device Key"}
                            id={"device_key"}
                            name={"device_key"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Secret Key"}
                            id={"secret_key"}
                            name={"secret_key"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Merchant Key"}
                            id={"merchant_key"}
                            name={"merchant_key"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Api Kullanıcı Adı"}
                            id={"api_username"}
                            name={"api_username"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Api Kullanıcı Parola"}
                            id={"api_password"}
                            name={"api_password"}
                        />
                    </>
                )}
                {isPavo && (
                    <>
                        <EkoFormInputText
                            {...fields}
                            label={"Hedef Cihaz Numarası"}
                            id={"pavo_target_serial_no"}
                            name={"pavo_target_serial_no"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Uygulama Adı"}
                            id={"pavo_application_name"}
                            name={"pavo_application_name"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Cihaz Adı"}
                            id={"pavo_source_reference"}
                            name={"pavo_source_reference"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"App Token"}
                            id={"pavo_app_token"}
                            name={"pavo_app_token"}
                        />
                        <EkoFormInputText
                            {...fields}
                            label={"Api Key"}
                            id={"pavo_api_key"}
                            name={"pavo_api_key"}
                        />
                    </>
                )}
            </>
        );
    }

    deleteButtonHandler(id) {
        toastr.confirm(
            "Silmek istediğinize emin misiniz?",
            {
                onOk: () => {
                    Api.post("/company/paymentRecorderDeviceDelete", {id:id}, (res, err) => {
                        if (err) {
                            toastr.error("Hata", err.error ?? "Beklenmeyen bir hata oluştu!");
                            return;
                        }
                        toastr.success("Başarılı", "Kayıt başarıyla silindi");

                        this.componentWillMount();
                    });
                },
                onCancel: () => {},
                okText: "Evet",
                cancelText: "Hayır",
            },
            "warning"
        );
    }

    openModal(record){
        const selectedIds = record && record.user ? record.user.map(u => u.user_id) : [];
        this.setState({ 
            selectedRecordPermission: record,
            selectedUserIds: selectedIds,
            showUsersModal: true 
        });
    }
    saveUserPermissions = () => {
        const allUserIds = this.state.users.map(user => user.id);
        const selectedIds = this.state.selectedUserIds;
        const unselectedIds = allUserIds.filter(id => !selectedIds.includes(id));
        const data = {
            device_id: this.state.selectedRecordPermission?.id,
            selected_user_ids: selectedIds,
            unselected_user_ids: unselectedIds
        };
        Api.post("/company/paymentRecorderDevicePermissionUpdate", data, (res, err) => {
            if (err) {
                toastr.error("Hata", err.error ?? "Beklenmeyen bir hata oluştu!");
                this.getList();
            } else {
                this.getList();
                toastr.success("Başarılı", "Kullanıcı yetkileri güncellendi.");
                this.setState({ 
                    showUsersModal: false,
                    selectedUserIds: []
                });
            }
        });
    }
    render() {
        let url = process.env.REACT_APP_API_URL.substr(
            0,
            process.env.REACT_APP_API_URL.length - 3
        );
        return (
            <>
                {this.state.page_loading === true ? (
                    <EkoSpinner />
                ) : (
                    <div className="portlet light">
                        <div className="portlet-title">
                            <div className="caption font-dark">
                <span className="caption-subject bold uppercase">
                  Ödeme Kaydedici Cihaz Entegrasyonları
                </span>
                            </div>
                            <div className="pull-right">
                                <EkoFormButton
                                    onClick={this.openInsert.bind(this)}
                                    label={"Yeni Ekle"}
                                />
                            </div>
                        </div>

                        <div className="portlet-body">
                            <div className={"row"}>
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Adı</th>
                                        <th>Nakit Kasa</th>
                                        <th>Kredi Kartı Kasa</th>
                                        <th>Depo</th>
                                        <th>İşlemler</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.records.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" style={{ textAlign: "center" }}>
                                                Kayıtlı hesabınız bulunamadı. Lütfen sağ üst
                                                köşeden yeni bir hesabı entegre edin.
                                            </td>
                                        </tr>
                                    ) : (
                                        this.state.records.map((record) => {
                                            return (
                                                <tr key={record.id}>
                                                    <td>{record.title}</td>
                                                    <td>{record.cash_bank}</td>
                                                    <td>{record.credit_card_bank}</td>
                                                    <td>{record.warehouse}</td>
                                                    <td>
                                                        <i 
                                                            className="fa fa-list btn btn-default blue" 
                                                            style={{ cursor: 'pointer', marginRight: '5px',padding: '7px',width:"50px" }}
                                                            onClick={() => this.openModal(record)}
                                                            title="Yetkili Kullanıcılar"
                                                        ></i>
                                                        {record.device_type === 0?<a className={"btn btn-default blue"} href={url+'quick_order/index.php?device_id='+record.id+'&t='+localStorage.getItem("token")} target="_blank"><i className="fa fa-eye" /></a>:""}
                                                        
                                                        <EkoFormButton
                                                            onClick={() => this.openInsert(record)}
                                                            label={"Düzenle"}
                                                        />
                                                        <EkoFormButton
                                                            onClick={this.deleteButtonHandler.bind(
                                                                this,
                                                                record.id
                                                            )}
                                                            label={"Sil"}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <PaymentRecorderDeviceInfoModal
                            title={"Yeni Ekle"}
                            showModal={this.state.showInsertModal}
                            formElements={this.form.bind(this)}
                            onHide={this.hideModalHandler.bind(this)}
                            defaultValues={this.state.selectedRecord}
                        />
                        <EkoModal
                    showModal={this.state.showUsersModal}
                    title="Yetkili Kullanıcılar"
                    onHide={() => {
                        this.setState({ 
                            showUsersModal: false,
                            selectedUserIds: []
                        });
                    }}
                >
                    <div>
                        {this.state.users && this.state.users.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th style={{width:"30px"}}>Seç</th>
                                            <th>Ad Soyad</th>
                                            <th>Email</th>
                                            <th>Telefon</th>
                                            <th>Durum</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.users.map((user, index) => (
                                            <tr key={user.id}>
                                                <td>
                                                    <input 
                                                        type="checkbox" 
                                                        id={`user_${user.id}`}
                                                        checked={this.state.selectedUserIds.includes(user.id)}
                                                        onChange={(e) => {
                                                            const userId = user.id;
                                                            let newSelectedIds = [...this.state.selectedUserIds];
                                                            
                                                            if (e.target.checked) {
                                                                if (!newSelectedIds.includes(userId)) {
                                                                    newSelectedIds.push(userId);
                                                                }
                                                            } else {
                                                                newSelectedIds = newSelectedIds.filter(id => id !== userId);
                                                            }
                                                            
                                                            this.setState({ selectedUserIds: newSelectedIds });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    {user.firstname && user.lastname 
                                                        ? `${user.firstname} ${user.lastname}` 
                                                        : 'Belirtilmemiş'
                                                    }
                                                </td>
                                                <td>{user.email}</td>
                                                <td>{user.phone || 'Belirtilmemiş'}</td>
                                                <td>
                                                    <span className={`badge ${user.is_activated ? 'badge-success' : 'badge-warning'}`}>
                                                        {user.is_activated ? 'Aktif' : 'Pasif'}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="text-right mt-3">
                                    <EkoFormButton
                                        label={"Kaydet"}
                                        type="button"
                                        className="btn btn-success"
                                        onClick={this.saveUserPermissions}
                                    />
                                </div>
                            </div>
                        ) : (
                            <p>Kullanıcı bulunamadı.</p>
                        )}
                    </div>
                </EkoModal>
                    </div>
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        viewOptions: state.data.viewOptions,
    };
}

export default connect(mapStateToProps, actions)(paymentRecorderDeviceInfo);
